import { Browser, browserInfo } from 'src/utils/client';
export const getParams = (url) => {
    const params = {};
    const urlParams = new URL(url).searchParams;
    urlParams.forEach((value, key) => {
        params[key] = value;
    });
    return params;
};
export const BrowserUrlMaxLength = {
    [Browser.Chrome]: 32_779,
    [Browser.Firefox]: 64_000,
    [Browser.Edge]: 2_083,
    [Browser.Safari]: 64_000,
    [Browser.InternetExplorer]: 2_083,
    [Browser.Unknown]: 2_083
};
export const maxLength = (function computeLen() {
    const browser = browserInfo.name;
    const maxMsIISLen = 16_384;
    return Math.min(BrowserUrlMaxLength[browser], maxMsIISLen);
}());
